import { STICKY_NODE } from '@mbrtargeting/metatag-shared-modules';
import { CONFIG_RESOLVER } from '../../loader/token.js';
import { Registry } from '../../loader/di/registry.js';
import { EffectFunction } from './index.js';
import { ADHESION_UNIT_WATCHER } from '../token.js';
import { selectFeatureSettings } from '../../loader/essentials/config-selector.js';


export const STICKY_NODE2: EffectFunction = (adSlot) => {

    const { slotHull: targetNode } = adSlot;
    const { stabilizeWidthForSticky = 0 } = adSlot.getPositionSettings();
    const stabilizedWidth = Math.max(stabilizeWidthForSticky, 0);

    const adhesionUnitWatcher = Registry.lookup(ADHESION_UNIT_WATCHER);
    const config = Registry.lookup(CONFIG_RESOLVER);

    const { stickyStopUnitQuery, stickyStop } = config.get(selectFeatureSettings());

    return STICKY_NODE({
        targetNode,
        stickyStopUnitQuery,
        stickyStop,
        adhesionUnitWatcher: adhesionUnitWatcher,
        stabilizedWidth,
    })
}
